import { TableWrapper } from '@basqet-dashboard/common/components';
import { useFetchBeneficiaries } from '@hooks/queries';
import React from 'react';

const BulkBeneficiaries = () => {
  const {
    isLoading,
    beneficiaries,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    searchQuery,
    setSearchQuery,
    isRefetching,
    filterByDate
  } = useFetchBeneficiaries({ grouped: true });
  let showIsFetching = (!beneficiaries.length && isLoading) || searchQuery || isRefetching;

  const formattedBeneficiaries = beneficiaries.map((beneficiary) => ({
    ...beneficiary,
    row_count: <span className="row-count">{beneficiary.row_count}</span>
  }));

  return (
    <TableWrapper
      data={formattedBeneficiaries}
      title="List of "
      name="bulk beneficiaries"
      headerName="bulk_beneficiaries"
      link={{
        url: '/settings/beneficiary/single',
        position: 'top',
        text: 'See single beneficiaries'
      }}
      exportData
      hasFilters
      onLoadMore={fetchNextPage}
      canLoadMore={hasNextPage}
      isFetching={showIsFetching}
      isLoading={isFetchingNextPage}
      onSearch={setSearchQuery}
      onDateFilter={filterByDate}
    />
  );
};

export { BulkBeneficiaries };
